/**
 * A class that represents a single key-value pair in a resource's metadata.
 */
export class Metadatum {
  /**
   * The key
   */
  public key: string = '';

  /**
   * The value
   */
  public value: string = '';
}
